import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AppBaseLayout } from "../../../components/layout/app-base-layout.tsx";

export const Route = createFileRoute("/_auth/app/_app")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<AppBaseLayout>
			<Outlet />
		</AppBaseLayout>
	);
}
